import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-agcharts',
	templateUrl:'./AgChartsPluginPage.html',
	styles: [],
	styleUrls:['./AgChartsPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgChartsPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_501 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>agcharts</artifactId>
</dependency>
\`\`\``;
	mdContent_502 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:agcharts:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_503 = `\`\`\`json
"ag-charts-community": "^13.1.0"
"ag-charts-angular": "^13.1.0"
\`\`\``;
	mdContent_504 = `\`\`\`java
@NgComponent
public class SalesChart implements INgComponent<SalesChart> {
    public AgChartOptions<SalesChart> getOptions() {
        return new AgChartOptions<>(this)
            .setSeries(List.of(
                new AgLineSeriesOptions<>()
                    .setXKey("month")
                    .setYKey("sales")
                    .setYName("Sales")
            ))
            .setAxes(List.of(
                new AgCategoryAxisOptions<>()
                    .setPosition(AgCartesianAxisPosition.BOTTOM),
                new AgNumberAxisOptions<>()
                    .setPosition(AgCartesianAxisPosition.LEFT)
            ));
    }
}
\`\`\``;
	mdContent_505 = `\`\`\`java
var chart = new AgPieChart<>();
chart.getOptions()
    .setSeries(List.of(
        new AgPieSeriesOptions<>()
            .setAngleKey("value")
            .setLegendItemKey("label")
    ));
\`\`\``;
	mdContent_506 = `\`\`\`java
@NgComponent
public class SalesChart implements INgComponent<SalesChart> {
    public AgChartOptions<SalesChart> getOptions() {
        return new AgChartOptions<>(this)
            .setSeries(List.of(
                new AgLineSeriesOptions<>()
                    .setXKey("month")
                    .setYKey("sales")
                    .setYName("Sales")
            ))
            .setAxes(List.of(
                new AgCategoryAxisOptions<>()
                    .setPosition(AgCartesianAxisPosition.BOTTOM),
                new AgNumberAxisOptions<>()
                    .setPosition(AgCartesianAxisPosition.LEFT)
            ));
    }
}
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
